import React, { useEffect } from 'react'
import CommonVideoCard from '../common-video-card'
import CommonVideoCardItem from '../common-video-card/item'
import { ICommonVideoData } from '../../services/home'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'array-flat-polyfill'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { useInView } from 'react-intersection-observer'
const titleIcon = require('static/original.png')

interface IProps {
  data: ICommonVideoData[]
  categoryListPGCData: { column_id: number; name: string }[]
}

const renderSlider = (groups: any, activeIndex: number, breakPoint: any) => {
  const perViewItemsCount =
    (breakPoint?.slidesPerView || 1) * (breakPoint?.slidesPerColumn || 1)

  return groups?.flat().map((item: any, index: number) => {
    const videoInfo = {
      coverUrl: item.video_info.cover_url,
      videoDuration: item.video_info.video_duration,
      videoWatchCount: item.video_info.video_watch_count,
      videoSize: item.video_info.video_size,
    }
    const column = {
      id: item.column.id,
      logo: item.column.logo,
      name: item.column.name,
      introduction: item.column.introduction,
      description: item.column.description,
      episode: item.column.episode,
      modify_time: item.column.modify_time,
      publish_time: item.publish_time,
    }

    return (
      <SwiperSlide key={index}>
        <CommonVideoCardItem
          order={index % perViewItemsCount}
          activeIndex={activeIndex}
          itemTeaParams={{
            page_id: 'page_main_new',
            event_id: 'org_program_module_card_content',
            module_id: 'org_program_module',
          }}
          titleTeaParams={{
            page_id: 'page_main_new',
            event_id: 'org_program_module_card_title',
            module_id: 'org_program_module',
          }}
          key={index}
          title={item?.title}
          uniqueIdStr={item.unique_id_str}
          videoInfo={videoInfo}
          column={column}
        />
      </SwiperSlide>
    )
  })
}

const HomeOriginal: React.FC<IProps> = ({ data, categoryListPGCData }) => {
  const [ref, inView] = useInView({
    threshold: 0,
  })

  useEffect(() => {
    if (inView) {
      sendTeaCommEvent('show_event', {
        page_id: 'page_main_new',
        event_id: 'common_conponent_module',
        module_id: 'org_program_module',
      })
    }
  }, [inView])

  if (categoryListPGCData?.length > 8) {
    categoryListPGCData.length = 8
  }

  const filterCategoryListPGCData = categoryListPGCData?.filter((t) => !!t)

  return (
    <div className="home-orignal-card" ref={ref} style={{ marginTop: 30 }}>
      <CommonVideoCard
        list={data}
        onTitleClick={() => {
          sendTeaCommEvent('clk_event', {
            page_id: 'page_main_new',
            event_id: 'org_program_module_title',
            module_id: 'org_program_module',
            module_title: '原创视频',
          })
        }}
        onNavItemClick={(item) => {
          sendTeaCommEvent('clk_event', {
            page_id: 'page_main_new',
            event_id: 'org_program_module_keywords',
            module_id: 'org_program_module',
            button_name: item.label,
          })
        }}
        navList={filterCategoryListPGCData?.map((item, index) => ({
          link: `/video/groups/${item?.column_id}`,
          label: item?.name,
          className: index + 1 > 5 ? 'tw-hidden xl:tw-block' : '',
        }))}
        more="/video/groups?category=懂车帝原创"
        titleIcon={{
          label: titleIcon,
          link: '/video/groups?category=懂车帝原创',
        }}
        renderSlider={renderSlider}
        swiperConfig={{
          slidesPerGroup: 4,
          slidesPerView: 4,
          spaceBetween: 12,
          onSlideChange: () => {
            sendTeaCommEvent('clk_event', {
              page_id: 'page_main_new',
              event_id: 'org_program_module_change',
              module_id: 'org_program_module',
            })
          },
          breakpoints: {
            1920: {
              slidesPerView: 5,
              slidesPerGroup: 5,
            },
          },
        }}
      />
    </div>
  )
}

export default HomeOriginal
